import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { getApiErrorMessage } from './store/constants/apiErrorMessage';

import './config';
import store from '../src/store';
import { ContextProvider } from './store/context';
import App from './App';
import './styles/suppliers-fix.scss';

// Amplify
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
Amplify.configure(awsconfig);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, 
      retry: 1, 
      onError: (error) => {
        const errorMessage = getApiErrorMessage(error);
        console.error('Query Error', errorMessage);
      },
    },
    mutations: {
      retry: 1,
      onError: (error) => {
        const errorMessage = getApiErrorMessage(error);
        console.error('Mutation Error', errorMessage);
      },
    },
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ContextProvider>
      {/* Agregadas future flags de React Router v7 para evitar warnings de deprecación */}
      <BrowserRouter
        future={{
          v7_startTransition: true,      // Prepara para React.startTransition en v7
          v7_relativeSplatPath: true     // Corrige resolución de rutas relativas en v7
        }}
      >
        <QueryClientProvider client={queryClient}>
          <App />
          {/* <ReactQueryDevtoolsPanel /> */}
        </QueryClientProvider>
      </BrowserRouter>
    </ContextProvider>
  </Provider>
);

if (window.Cypress) {
  window.store = store;
}

serviceWorkerRegistration.register({
  onUpdate: async registration => {
    if (registration && registration.waiting) {
      await registration.unregister();
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  }
});
